export default "__VITE_ASSET__DwKvnoVn__"